import { UPDATE_INVITE_INFO_FROM_LEAD_INQUIRY } from '../constants/actionTypes';
import { getLeadDetails, sendInvitationApi } from '../utils/api';
import { loadListingApplicationsTabData } from '../actions/initListingActionCreators';
import { INVITE_RENTER_TO_APPLY_CLICK, INVITE_TO_APPLY_MODAL_REQUEST_CLOSE } from '../constants/actions';
import { SEND_APPLICATION_INVITATION } from '../constants/requests';
import { logError } from '@zg-rentals/log-error';

export function updateInviteInfoFromLeadInquiry(payload) {
  return { type: UPDATE_INVITE_INFO_FROM_LEAD_INQUIRY, payload };
}

export function sendInvitationRequest() {
  return {
    type: SEND_APPLICATION_INVITATION.REQUEST,
  };
}

export function sendInvitationReceive() {
  return {
    type: SEND_APPLICATION_INVITATION.RECEIVE,
  };
}

export function sendInvitationFailure() {
  return {
    type: SEND_APPLICATION_INVITATION.FAILURE,
  };
}

export function sendApplicationInvitationApi(payload) {
  return async (dispatch) => {
    dispatch(sendInvitationRequest());
    try {
      const response = await dispatch(sendInvitationApi(payload));
      if (response && response.status === 200) {
        return dispatch(sendInvitationReceive());
      }
      return dispatch(sendInvitationFailure());
    } catch (error) {
      logError({ context: 'Failed to send invitation email.', error });
      return dispatch(sendInvitationFailure());
    }
  };
}

export function sendApplicationInvitation(payload) {
  const { listingId } = payload;
  return async (dispatch) => {
    const sendApplicationInvitationApiResponse = await dispatch(sendApplicationInvitationApi(payload));
    if (sendApplicationInvitationApiResponse.type === SEND_APPLICATION_INVITATION.RECEIVE) {
      dispatch(loadListingApplicationsTabData({ listingId: listingId }));
    }
  };
}

function setInviteInfoFromLeadInquiry(leadId) {
  return (dispatch) => {
    if (typeof leadId === 'undefined' || !leadId) {
      dispatch(updateInviteInfoFromLeadInquiry({ inviteInfoFromLeadInquiry: null }));
      return Promise.resolve(false);
    }
    const payload = { inquiryId: leadId, includeListingDetails: false };
    return dispatch(getLeadDetails(payload)).then(
      (response = {}) => {
        if (
          response &&
          response.status === 200 &&
          response.data &&
          response.data.response &&
          response.data.response.inquiry
        ) {
          const inquiry = response.data.response.inquiry;
          dispatch(updateInviteInfoFromLeadInquiry({ inviteInfoFromLeadInquiry: inquiry }));
          return true;
        } else {
          dispatch(updateInviteInfoFromLeadInquiry({ inviteInfoFromLeadInquiry: null }));
          return false;
        }
      },
      () => {
        dispatch(updateInviteInfoFromLeadInquiry({ inviteInfoFromLeadInquiry: null }));
        return false;
      },
    );
  };
}

export function inviteRenterToApplyClick() {
  return {
    type: INVITE_RENTER_TO_APPLY_CLICK,
  };
}

export function inviteToApplyModalRequestClose() {
  return {
    type: INVITE_TO_APPLY_MODAL_REQUEST_CLOSE,
  };
}

export { setInviteInfoFromLeadInquiry };
